import React, { FC } from 'react';
import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import { leftovers } from 'src/utils/links';
import { generateComment } from '../utils';

const UpdateBookingStatus: FC = () => {
  return (
    <div>
      <p>Ми рекомендуємо таку логіку завантаження інформаціі про залишки:</p>
      <ul className="indent-6">
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            Раз на добу завантажувати повні прайси аптек з параметром
            &quot;deleteOther&quot;: true
          </span>
        </li>
        <li>
          <span className="before:content-['•'] before:mr-0.5 before:text-astronautBlue-500">
            Раз на 10-30 хвилин присилати тількі ті залишки, що змінилися з
            параметром &quot;deleteOther&quot;: false
          </span>
        </li>
      </ul>
      <p>
        Така логіка дозволить швидко завантажувати зміни по залишкам на не
        наватажувати вашу і нашу систему даними, що не змінюються. А також раз
        на добу завантажувати все з нуля, щоб виключити ситуації с загубленими
        залишками.
      </p>
      <p>
        <span className="fs-body-bold">POST </span>
        <NavigationLink passClassName="underline " href={leftovers}>
          {leftovers}
        </NavigationLink>
      </p>
      <p>Request:</p>
      <pre>
        <code>
          &#123;
          <p className="indent-6">
            &quot;deleteOther&quot;: false,{' '}
            {generateComment('чи видаляти аптеки, що не прийшли у запиті')}
          </p>
          <p className="indent-6">
            &quot;branchId&quot;: &quot;123456&quot;,{' '}
            {generateComment('код аптеки')}
          </p>
          <p className="indent-6">&quot;rests&quot;: &#91;&#123;</p>
          <p className="indent-12">
            &quot;code&quot;: &quot;123155&quot;,{' '}
            {generateComment('код товара')}
          </p>
          <p className="indent-12">
            &quot;price&quot;: 100.01, {generateComment('роздрібна ціна')}
          </p>
          <p className="indent-12">
            &quot;priceReserve&quot;: 90.99,{' '}
            {generateComment('ціна для бронювання')}
          </p>
          <p className="indent-12">
            &quot;quantity&quot;: 15,{' '}
            {generateComment('кількість упаковок на залишку')}
          </p>
          <p className="indent-12">
            &quot;morionCode&quot;: &quot;123455&quot;,{' '}
            {generateComment('код Моріон')}
          </p>
          <p className="indent-12">
            &quot;quantityInPack&quot;: 10{' '}
            {generateComment('кількість блістерів в упаковці')}
          </p>
          <p className="indent-10">&#125;&#93;</p>
          &#125;
        </code>
      </pre>
    </div>
  );
};

export default UpdateBookingStatus;
